/**
 * The Numeo teardrop map pin (coloured drop + white disc + coloured letter) as an SVG string.
 * Shared so the Leaflet route map (load-hub, via `L.divIcon`) and the Google route map (box-truck, via an
 * SVG data-URI marker icon) render byte-identical pins from one formula.
 */
export function pinSvg(color: string, letter: string, w = 28, h = 40): string {
    const cx = w / 2
    const cy = w / 2
    const r = w * 0.21
    const fontSize = w * 0.42
    return `<svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M${cx} 0C${(cx * 5.373) / 12} 0 0 ${(cx * 5.373) / 12} 0 ${cx}C0 ${(cx * 21) / 12} ${cx} ${h} ${cx} ${h}S${w} ${(cx * 21) / 12} ${w} ${cx}C${w} ${(cx * 5.373) / 12} ${(cx * 18.627) / 12} 0 ${cx} 0Z" fill="${color}"/><circle cx="${cx}" cy="${cy}" r="${r}" fill="white"/><text x="${cx}" y="${cy + r * 0.8}" text-anchor="middle" font-family="Arial, sans-serif" font-size="${fontSize}" font-weight="bold" fill="${color}">${letter}</text></svg>`
}
